import { Container } from '../../../odie';

import { SlimeBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

// constants
//-----------------------------------------------------------------------------
const manifest = {
  image: 'slime/block.slime.png',
};

/*
    slime block view
*/
export class SlimeBlockView extends Container {
  // init
  //-------------------------------------------------------------------------
  constructor(props: SlimeBlockProps) {
    // create base view
    super();

    const sprite = new FitWidthBlockSprite(manifest.image, props);

    this.addChild(sprite);

    // position
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
